import React from 'react';
import { ImPrevious, ImNext } from 'react-icons/im';
import { HiDotsHorizontal } from 'react-icons/hi';

import { usePagination, DOTS } from './usePagination.js';
import './Pagination.scss';

const Pagination = ({
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize }) => {

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // Only hide pagination when there are no results or invalid page
    if (currentPage === 0 || totalCount === 0) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    let num = 0;
    return (
        <ul
            className="pagination_container"
        >
            {/* Left navigation arrow */}
            {currentPage === 1 ? "" : <li className="pagination_item" onClick={onPrevious}>
                <ImPrevious size={26} />
            </li>}
            {paginationRange.map(pageNumber => {
                num += 1;
                // If the pageItem is a DOT, render the DOTS unicode character
                if (pageNumber === DOTS) {
                    return <li key={num} className={`pagination_item dots`}><HiDotsHorizontal size={26} /></li>;
                }

                // Render our Page Pills
                return (
                    <li key={num}
                        className={pageNumber === currentPage ? `pagination_item selected` : "pagination_item"}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </li>
                );
            })}
            {/*  Right Navigation arrow */}
            {currentPage === lastPage ? "" :
                <li className="pagination_item" onClick={onNext}>
                    <ImNext size={26} />
                </li>
            }
        </ul >
    );
};

export default Pagination;